import { useTranslation } from "react-i18next";

import { I18N_PUBLIC_NAMESPACE } from "@ryde/shared";

/** Login sits outside the session catalogue; binding to `general` suspends the root spinner on logout. */
export const useLoginTranslation = () => useTranslation(I18N_PUBLIC_NAMESPACE);
